import React from 'react'
import { M_Table } from 'src/components/M_Components'

export const Incidences = ({ roles }) => {

    return (
        <M_Table entityName={'ServiceOrderStateReason'} filtersOnTable rolePermissions={roles} roleName="Incidences" />
    )
}